import { cva } from 'class-variance-authority'

/**
 * Promo Block CVA Configuration
 *
 * Styles for homepage promotional blocks with image + content layout
 */

/**
 * Promo block section container
 */
export const promoBlockSectionVariants = cva('w-full min-h-[400px] md:min-h-[500px] md:max-h-[600px] md:overflow-hidden')

/**
 * Promo block flex container
 */
export const promoBlockContainerVariants = cva(
  'flex flex-col md:flex-row min-h-[400px] md:min-h-[500px] md:max-h-[600px]',
  {
    variants: {
      imagePosition: {
        left: '',
        right: 'md:flex-row-reverse',
      },
    },
    defaultVariants: {
      imagePosition: 'left',
    },
  }
)

/**
 * Promo block image section
 */
export const promoBlockImageSectionVariants = cva('w-full md:w-1/2 h-[36rem] md:h-auto overflow-hidden')

/**
 * Promo block image link wrapper
 */
export const promoBlockImageLinkVariants = cva('block w-full h-full')

/**
 * Promo block image
 */
export const promoBlockImageVariants = cva('w-full h-full object-cover')

/**
 * Promo block content section
 */
export const promoBlockContentSectionVariants = cva([
  'w-full md:w-1/2 bg-gray-100',
  'flex items-center justify-center',
  'px-6 py-12 md:px-12 lg:px-16',
])

/**
 * Promo block content inner wrapper — text-center on all breakpoints, with
 * vertical rhythm via space-y so title / description / CTA breathe equally.
 */
export const promoBlockContentInnerVariants = cva('text-center max-w-lg space-y-8 md:space-y-10')

/**
 * Promo block title — bottom margin removed; spacing handled by parent space-y.
 */
export const promoBlockTitleVariants = cva(
  'text-2xl md:text-3xl lg:text-4xl font-bold uppercase tracking-wide'
)

/**
 * Promo block description — bumped up one size for readability; bottom margin
 * removed; centered alignment inherited from parent.
 */
export const promoBlockDescriptionVariants = cva(
  'text-gray-600 text-2xl md:text-3xl leading-relaxed'
)

/**
 * Promo block skeleton - content wrapper
 */
export const promoBlockSkeletonContentVariants = cva([
  'w-full md:w-1/2 bg-gray-100',
  'flex items-center justify-center',
  'px-6 py-12 md:px-12 lg:px-16',
  'min-h-[300px] md:min-h-[500px]',
])

/**
 * Promo block skeleton - inner content
 */
export const promoBlockSkeletonInnerVariants = cva('w-full max-w-lg space-y-6')
